
export default {
  props: {
    currentView: {
      type: String,
      default: 'play-mix-service-info'
    },
    identifier: {
      type: String,
      default: ''
    }
  },
  computed: {
    currentComponent() {
      return this.currentView
    },
    currentViewProps() {
      if (this.currentView === 'play-mix-services-info') {
        return { identifier: this.identifier }
      }
      return {}
    }
  }
}
